import { render } from "./CategoryDetailView.vue?vue&type=template&id=55f461fc"
import script from "./CategoryDetailView.vue?vue&type=script&lang=js"
export * from "./CategoryDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__